{
  "name": "saaj",
  "version": "2.0.0",
  "description": "Add components to your apps.",
  "publishConfig": {
    "access": "public"
  },
  "author": {
    "name": "sarabjit20s",
    "url": "https://github.com/sarabjit20s"
  },
  "repository": {
    "type": "git",
    "url": "https://github.com/sarabjit20s/saaj-ui",
    "directory": "packages/cli"
  },
  "license": "MIT",
  "keywords": [
    "saaj",
    "saaj-ui",
    "components",
    "react-native",
    "expo",
    "react-native-unistyles",
    "unistyles"
  ],
  "type": "module",
  "files": [
    "dist"
  ],
  "exports": {
    ".": {
      "types": "./dist/index.d.ts",
      "default": "./dist/index.js"
    }
  },
  "bin": "./dist/index.js",
  "scripts": {
    "build": "tsup",
    "dev": "tsup --watch",
    "format": "prettier --write \"**/*.{ts,tsx,md}\"",
    "pub:beta": "pnpm build && pnpm publish --no-git-checks --access public --tag beta",
    "pub:latest": "pnpm build && pnpm publish --no-git-checks --access public"
  },
  "dependencies": {
    "@babel/generator": "^7.28.6",
    "@babel/parser": "^7.28.6",
    "@babel/traverse": "^7.28.6",
    "@babel/types": "^7.28.6",
    "chalk": "^5.4.1",
    "colorjs.io": "^0.5.2",
    "commander": "^13.0.0",
    "cosmiconfig": "^9.0.0",
    "deepmerge": "^4.3.1",
    "execa": "^9.6.1",
    "fast-glob": "^3.3.3",
    "fs-extra": "^11.3.3",
    "package-manager-detector": "^1.6.0",
    "plist": "^3.1.0",
    "prompts": "^2.4.2",
    "ts-morph": "^27.0.2",
    "tsconfig-paths": "^4.2.0",
    "yocto-spinner": "^0.1.2",
    "zod": "^4.2.1"
  },
  "devDependencies": {
    "@types/babel__generator": "^7.27.0",
    "@types/babel__traverse": "^7.28.0",
    "@types/fs-extra": "^11.0.4",
    "@types/node": "22.10.2",
    "@types/plist": "^3.0.5",
    "@types/prompts": "^2.4.9",
    "tsup": "^8.3.5",
    "type-fest": "^5.3.1",
    "typescript": "^5.7.3"
  }
}
